import React from "react";
import { DtGridPropsOptions2 } from "../../../types/dtGridPropsOptions2";
import _ from "lodash";
import { useSelector } from "react-redux";
import { IRootState } from "../../../types/redux/IRootStore";
import { workorderManagementOperationsPaneColumns } from "./WorkorderManagementOperationsPaneColumns";
import { useAppDispatch } from "../../../redux/hooks";
import { DtGrid2 } from "../../common/DtGrid2";
import { onSetSelectedOperations, workorderManagementOperations } from "../../../redux/slices/workorderManagement.feature";
import { translateColumns } from "../../../translations/gridTranslationHelper";
import AplSettingsSelector from "../../../redux/helpers/AplSettingsSelector";
import { getWorkorderStatus } from "../../../aplUtils/statusConditionEnumHelper";
import { useTranslation } from "react-i18next";
import { WorkorderManagementOperation } from "../../../types/workorderManagementOperation";
import { saveWorkorderManagementOperation } from "../../../aplApi/workorderManagementHelper";
import { parseChangeEvent } from "../../../aplUtils/formHelper";
import { AplParameter } from "../../../types/aplParameter";
import { parseBool } from "../../../aplUtils/extensions";

export default function WorkorderManagementOperationsPane() {
    const { t } = useTranslation();
    const workorderManagementRedux = useSelector((state: IRootState) => state.workorderManagement);
    const aplSettings = AplSettingsSelector();
    const dispatch = useAppDispatch();
    const showJobInStr = aplSettings.siteParams.find(p => p.aplParameterType === AplParameter.InlineConsumption);
    const showJobIn = parseBool(showJobInStr?.value);

    const setSelected = (x: any) => {
        dispatch(onSetSelectedOperations(x));
    };

    const dtGridOptns: DtGridPropsOptions2 = {
        data: workorderManagementRedux.orderOperationsData,
        columnData: translateColumns(workorderManagementOperationsPaneColumns(aplSettings.culture, showJobIn), aplSettings.culture),
        defaultSort: {
            field: [],
            direction: []
        },
        selectType: "single",
        colouring: false,
        headerFilters: false,
        setSelectedItems: setSelected,
        selectedItems: workorderManagementRedux.orderOperationsSelected,
        tableName: "tblWorkorderOperations",
        tableClass: "table-workorder-operations",
        paging: false,
        showSpinner: workorderManagementRedux.orderOperationsDataLoading,
        rowId: "operationId",
        pageLength: 20,
        loading: workorderManagementRedux.orderOperationsDataLoading,
        bulk: false,
        filters: {},
        setFilters: _.noop,
        page: 1,
        setPage: _.noop
    };

    const onSubmit = async (e: any) => {
        let data: WorkorderManagementOperation = {
            ...workorderManagementRedux.orderOperationsSelected[0]
        };
        await saveWorkorderManagementOperation(data);
        dispatch(workorderManagementOperations(data.workorderId) as any);
    };

    const onChange = (e: any) => {
        let data = 
            {
                ...workorderManagementRedux.orderOperationsSelected[0],
                ...parseChangeEvent(e)
            } as WorkorderManagementOperation;
        
        let data2 = [{
            ...data,
            lineId: Number(data.lineId),
            worksOrderStatusIdConsumption: Number(data.worksOrderStatusIdConsumption),
            worksOrderStatusIdLabelling: Number(data.worksOrderStatusIdLabelling)
        } as WorkorderManagementOperation]
        dispatch(onSetSelectedOperations(data2));
    };

    return (
        <React.Fragment>
            <div className="container mw-100">
                <div className="row ml-1 mr-1">
                    <div className="col-sm-12">
                        <DtGrid2 options={dtGridOptns} />
                    </div>
                </div>
            </div>

            {workorderManagementRedux.orderOperationsSelected.length === 1 ? (
                <form onSubmit={onSubmit} onChange={onChange}>
                    <div className="container mw-100 p-2 pt-0 mt-1" id="wrkOpEdit">
                        <div className="row ml-2 mr-2">
                            <div className="col hide">
                                <input
                                    type="text"
                                    className="form-control hide"
                                    id="txtOpeId"
                                    value={workorderManagementRedux.orderOperationsSelected[0].operationId}
                                    name="operationId"
                                    onChange={() => {}}
                                />
                            </div>
                            <div className="col-sm-2">
                                {/* <!-- workcentre --> */}
                                <select
                                    id="ddOpeWorkcenter"
                                    className="form-control"
                                    name="lineId"
                                    value={workorderManagementRedux.orderOperationsSelected[0].lineId}
                                    onChange={() => {}}
                                >
                                    {workorderManagementRedux.orderOperationsSelected[0].lineItems.map(x => (
                                        <option key={x.lineId} value={x.lineId}>
                                            {x.lineDescription}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-sm-2">
                                {/* <!-- line name --> */}
                                <input
                                    type="text"
                                    className="form-control"
                                    readOnly={true}
                                    id="txtOpeLine"
                                    value={workorderManagementRedux.orderOperationsSelected[0].lineDescription}
                                    onChange={() => {}}
                                />
                            </div>
                            <div className="col-sm-2">
                                {/* <!-- consumption status --> */}
                                <select
                                    id="ddOpeConsumptionStatus"
                                    className="form-control float-right"
                                    value={workorderManagementRedux.orderOperationsSelected[0].worksOrderStatusIdConsumption}
                                    onChange={() => {}}
                                    name="worksOrderStatusIdConsumption"
                                >
                                    {workorderManagementRedux.orderOperationsSelected[0].workorderStatusesConsumption.map(x => (
                                        <option key={x.workorderStatusId} value={x.workorderStatusId}>
                                            {getWorkorderStatus(x.workorderStatusId, aplSettings.culture)}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-sm-2">
                                {/* <!-- labelling status --> */}
                                <select
                                    id="ddOpeLabellingStatus"
                                    className="form-control float-right"
                                    value={workorderManagementRedux.orderOperationsSelected[0].worksOrderStatusIdLabelling}
                                    onChange={() => {}}
                                    name="worksOrderStatusIdLabelling"
                                >
                                    {workorderManagementRedux.orderOperationsSelected[0].workorderStatusesLabelling.map(x => (
                                        <option key={x.workorderStatusId} value={x.workorderStatusId}>
                                            {getWorkorderStatus(x.workorderStatusId, aplSettings.culture)}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-sm-2">
                                {/* <!-- labelling status --> */}
                                {showJobIn ? (
                                    <select
                                        id="ddOpeInLine"
                                        className="form-control float-right"
                                        value={workorderManagementRedux.orderOperationsSelected[0].inLineId ?? undefined}
                                        onChange={() => {}}
                                        name="inLineId"
                                    >
                                        <option key={0} value={0}></option>
                                        {workorderManagementRedux.orderOperationsSelected[0].lineItems.map(x => (
                                            <option key={x.lineId} value={x.lineId}>
                                                {x.lineDescription}
                                            </option>
                                        ))}
                                    </select>
                                ) : (
                                    ""
                                )}
                            </div>
                            <div className="col-sm-2">
                                <input type="button" className="btn btn-primary float-right" onClick={onSubmit} value={t("main.save")!} />
                            </div>
                        </div>
                    </div>
                </form>
            ) : null}
        </React.Fragment>
    );
}
